import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../shared-components/System';
import { FieldsWithinForms, FieldUsedInForm, AccomodationBank, FormSetup, ComplianceRule, CategoryGrid, SpedCollection, SpedCollectionToIEPStatus, SpedCollectionTemplatesItem, SpedAvailableForms, Sequence } from './sped-management.model';

@Injectable({
  providedIn: 'root'
})
export class SpedManagementService {

  constructor(private http: HttpClient) { }

  getFieldWithinForms(): Observable<FieldsWithinForms[]> {
    return this.http.get<FieldsWithinForms[]>(System.apiURL.SpecialEd + 'GetFieldWithinForms');
  }

  getFieldUsedInTemplates(dataField: number): Observable<FieldUsedInForm[]> {
    const queryString = '?dataField=' + dataField;
    return this.http.get<FieldUsedInForm[]>(System.apiURL.SpecialEd + 'GetFieldUsedInTemplates' + queryString);
  }

  getIsComplianceFieldById(fieldName: string): Observable<boolean> {
    const queryString = '?fieldName=' + fieldName;
    return this.http.get<boolean>(System.apiURL.SpecialEd + 'GetSpEdComplianceFieldReadByFieldName' + queryString);
  }

  saveFieldWithinForms(data: FieldsWithinForms): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SpedDataFieldUpdate', data);
  }

  getAccomodation(spedlookupmasterid: number, displaymasteronly: boolean, spedlookupdataid: number, type: boolean): Observable<AccomodationBank[]> {
    const queryString = '?spedlookupmasterid=' + spedlookupmasterid + '&displaymasteronly=' + displaymasteronly + '&spedlookupdataid=' + spedlookupdataid + '&type=' + type;
    return this.http.get<AccomodationBank[]>(System.apiURL.SpecialEd + 'GetAccomodationGrid' + queryString);
  }

  getIdentificationCode(MasterDescription: string): Observable <AccomodationBank[]> {
    const queryString = '?MasterDescription=' + MasterDescription;
    return this.http.get<AccomodationBank[]>(System.apiURL.SpecialEd + 'GetIdentificationCode' + queryString);
  }

  updateAccommodation(data: AccomodationBank): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'UpdateAccommodation', data);
  }

  getSpedTemplateVersionRead(isPublished: boolean, status: number): Observable<FormSetup[]> {
    const queryString = '?isPublished=' + isPublished + '&status=' + status;
    return this.http.get<FormSetup[]>(System.apiURL.SpecialEd + 'GetSpedTemplateVersionRead' + queryString);
  }

  getTemplateFieldsReadByTemplateVersionId(templateVersionId: number): Observable<FieldsWithinForms[]> {
    const queryString = '?templateVersionId=' + templateVersionId;
    return this.http.get<FieldsWithinForms[]>(System.apiURL.SpecialEd + 'GetTemplateFieldsReadByTemplateVersionId' + queryString);
  }

  spedTemplateVersionUpdate(data: FormSetup): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SpedTemplateVersionUpdate', data);
  }

  getCompliance(): Observable<ComplianceRule[]> {
    return this.http.get<ComplianceRule[]>(System.apiURL.SpecialEd + 'SpedCollectionRead');
  }

  getComplianceSelectItem(collectionId: number): Observable<ComplianceRule[]> {
    const quertString = '?collectionId=' + collectionId;
    return this.http.get<ComplianceRule[]>(System.apiURL.SpecialEd + 'GetTemplatesItemRead' + quertString);
  }
  getComplianceGrid(stateCode: string, spedCollectionId: number, spedTemplateVersionId: number): Observable<ComplianceRule[]> {
    const quertString = '?stateCode=' + stateCode + '&spedCollectionId=' + spedCollectionId + '&spedTemplateVersionId=' + spedTemplateVersionId;
    return this.http.get<ComplianceRule[]>(System.apiURL.SpecialEd + 'GetComplianceGridData' + quertString);
  }
  updateCompliance(data: ComplianceRule): Observable<ComplianceRule[]> {
    return this.http.post<ComplianceRule[]>(System.apiURL.SpecialEd + 'UpdateComplianceData', data);

  }
  getCategoryGrid(Type: boolean): Observable<CategoryGrid[]> {
    const quertString = '?Type=' + Type;
    return this.http.get<CategoryGrid[]>(System.apiURL.SpecialEd + 'GetDataBankCategories' + quertString);
  }

  getObjectiveBankData(CategoryId: number, DataBankId: number, Type: boolean): Observable<CategoryGrid[]> {
    const queryString = '?CategoryId=' + CategoryId + '&DataBankId=' + DataBankId + '&Type=' + Type;
   return this.http.get<CategoryGrid[]>(System.apiURL.SpecialEd + 'GetDataBanks' + queryString);
 }

  addNewCategory(data: CategoryGrid): Observable<CategoryGrid[]> {
    return this.http.post<CategoryGrid[]>(System.apiURL.SpecialEd + 'DataBankCategoryCreate', data);
  }

  dataBankCategoryUpdate(data: CategoryGrid): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'DataBankCategoryUpdate', data);
  }

  dataBankCategoryDelete(DataBankCategoryID: number): Observable<void> {
    const queryString = '?DataBankCategoryID=' + DataBankCategoryID;
    return this.http.post<void>(System.apiURL.SpecialEd + 'DataBankCategoryDelete' + queryString, null);
  }

  updateDataBank(data: CategoryGrid): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'DataBankUpdate', data);
  }

  deleteDataBank(DataBankId: number): Observable<void> {
    const queryString = '?DataBankId=' + DataBankId;
    return this.http.post<void>(System.apiURL.SpecialEd + 'DataBankDelete' + queryString, null);
  }

  getSpedCollectionsReadByUserId(): Observable<SpedCollection[]> {
    return this.http.get<SpedCollection[]>(System.apiURL.SpecialEd + 'GetSpedCollectionsReadByUserId');
  }

  deleteSpedCollectionById(collectionId: number): Observable<boolean> {
    const queryString = '?collectionId=' + collectionId;
    return this.http.get<boolean>(System.apiURL.SpecialEd + 'DeleteSpedCollectionById' + queryString);
  }

  getSpedCollectionIEPStatusRead(spedCollectionId: number = 0): Observable<SpedCollectionToIEPStatus[]> {
    const queryString = '?spedCollectionId=' + spedCollectionId;
    return this.http.get<SpedCollectionToIEPStatus[]>(System.apiURL.SpecialEd + 'GetSpedCollectionIEPStatusRead' + queryString);
  }

  getSpedAvailableTemplates(): Observable<SpedAvailableForms[]> {
    return this.http.get<SpedAvailableForms[]>(System.apiURL.SpecialEd + 'GetSpedAvailableTemplates');
  }

  deleteSpedCollectionTemplateById(collectionTemplateId: number []): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'DeleteSpedCollectionTemplateById' , collectionTemplateId);
  }

  assignTemplateToCollection(collectionId: number, templateVersionIds: number []): Observable<SpedCollectionTemplatesItem[]> {
    const queryString = '?collectionId=' + collectionId;
    return this.http.post<SpedCollectionTemplatesItem[]>(System.apiURL.SpecialEd + 'AssignTemplateToCollection' + queryString, templateVersionIds);
  }

  templateInCollectionUpdate(data: SpedCollectionTemplatesItem []): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'TemplateInCollectionUpdate', data);
  }

  spedCollectionToIEPStatusUpdate(data: SpedCollectionToIEPStatus []): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SpedCollectionToIEPStatusUpdate', data);
  }

  viewFormSetupDocument(templateVersionId: number): Observable<string> {
    let queryString = '';
    queryString += '?templateVersionId=' + templateVersionId;
    return this.http.get<string>(System.apiURL.SpecialEd + 'ViewFormSetupDocument' + queryString);
  }

  saveSequence(data: Sequence[]): Observable<void> {
    return this.http.post<void>(System.apiURL.SpecialEd + 'SaveSequence', data);
  }
}